export interface IArmor {
	code: number;
	name: string;
	itemType: string;
	armorType: string;
	itemGrade: string;
	craftAnimTrigger: string;
	stackable: number;
	initialCount: number;
	makeMaterial1: number;
	makeMaterial2: number;
	attackPower: number;
	defense: number;
	maxHp: number;
	maxSp: number;
	hpRegenRatio: number;
	hpRegen: number;
	spRegenRatio: number;
	spRegen: number;
	attackSpeedRatio: number;
	criticalChance: number;
	criticalStrikeDamage: number;
	cooldownReduction: number;
	lifeSteal: number;
	moveSpeed: number;
	sightRange: number;
	outOfCombatMoveSpeed: number;
	attackRange: number;
	increaseBasicAttackDamage: number;
	preventBasicAttackDamaged: number;
	increaseSkillDamage: number;
	increaseSkillDamageRatio: number;
	preventSkillDamagedRatio: number;
	decreaseRecoveryToBasicAttack: number;
	decreaseRecoveryToSkill: number;
}
